import type React from 'react';
import getIsIframeLoaded from './getIsIframeLoaded';

export const reportAccessibility = async (App: typeof React, config?: Record<string, unknown>): Promise<void> => {
  const isIframeLoaded = getIsIframeLoaded(); // selectively exclude axe-core when iframe content loaded in cypress e2e tests

  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production' && !isIframeLoaded) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const axe = require('@axe-core/react'); // Use require so bundlers can treeshake this out in production
    const ReactDOM = await import('react-dom');

    axe(App, ReactDOM, 1000, config);
  }
};
